import OpenCallVoting from '../components/OpenCallVoting';
import PageLayout from '../components/pageLayout';

function OpenCallVotingPage() {
    return (
        <PageLayout children={<OpenCallVoting />} />
    );
}

export default OpenCallVotingPage;
